import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getDeliveredStatusList } from "utils/HelperSoFunction";
export var productSoList = [
    {
        key: "warehouseID",
        render: function(param) {
            var item = param.item, values = param.values, optionsWarehouse = param.optionsWarehouse, setProductRow = param.setProductRow;
            var _item_warehouseID;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID && /*#__PURE__*/ _jsxs("select", {
                            value: (_item_warehouseID = item.warehouseID) !== null && _item_warehouseID !== void 0 ? _item_warehouseID : "",
                            style: {
                                width: "100%",
                                border: !item.warehouseID ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        var selectedOption = e.target.options[e.target.selectedIndex];
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                warehouseID: e.currentTarget.value,
                                                warehouseName: selectedOption.text
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control sselectv",
                            disabled: true,
                            children: [
                                /*#__PURE__*/ _jsx("option", {
                                    value: "",
                                    disabled: true,
                                    children: "เลือกคลัง"
                                }, "default"),
                                optionsWarehouse && optionsWarehouse.map(function(v, index) {
                                    return /*#__PURE__*/ _jsx("option", {
                                        value: v.value,
                                        children: v.label
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productQty",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "!bg-[#FFEDE0]",
                        children: item.productID != "" ? /*#__PURE__*/ _jsx("input", {
                            type: "number",
                            className: "form-control formv text-center border-0 me-2 bg-[#FFEDE0] text-[#FF6B00]",
                            value: item.productQty,
                            onFocus: function(e) {
                                return e.target.select();
                            },
                            onWheel: function(e) {
                                return e.target.blur();
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                productQty: e.target.value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            }
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body !bg-[#FFEDE0]"
                    })
                ]
            });
        }
    },
    {
        insertAfter: "productQty",
        key: "productDelivered",
        render: function(param) {
            var item = param.item, values = param.values;
            if (!getDeliveredStatusList.includes(values.dim_mst_so_status_id)) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "!bg-[#E5ECFB]",
                        children: item.productID != "" ? /*#__PURE__*/ _jsx("div", {
                            className: "text-center border-0 me-2 bg-[#E5ECFB] text-[#565DFF]",
                            children: item.productDeliveredQty
                        }) : null
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body !bg-[#E5ECFB]"
                    })
                ]
            });
        }
    }
];
